import { gql } from '@apollo/client';

const GET_COUNTRIES = gql`
  query getCountries {
    countries: getCountries(sort: [{ property: "name", direction: "asc" }]) {
      id
      name
      code
      oldId
    }
  }
`;

const GET_TITLES = gql`
  query getTitles {
    titles: getTitles {
      id
      name
    }
  }
`;

const GET_COUNTIES_BY_COUNTRY_ID = gql`
  query getCounties($countryId: String!) {
    counties: getCounties(
      where: { countryId: $countryId }
      sort: [{ property: "name", direction: "asc" }]
    ) {
      code
      name
      countryId
      country {
        code
        name
      }
    }
  }
`;

const GET_PRODUCT_VARIANTS_QUERY = gql`
  query getProduct($id: String!) {
    product: getPublishedProduct(id: $id) {
      variants {
        variantId
        attributes
      }
    }
  }
`;

const GET_ECOMMERCE_PRODUCT_VARIANTS_QUERY = gql`
  query getProduct($id: String!, $currency: String) {
    variants: ecommerceGetProductVariants(id: $id, currency: $currency) {
      variantId
      name
      attributes
      price
      priceValue
    }
  }
`;

export {
  GET_COUNTRIES,
  GET_TITLES,
  GET_COUNTIES_BY_COUNTRY_ID,
  GET_PRODUCT_VARIANTS_QUERY,
  GET_ECOMMERCE_PRODUCT_VARIANTS_QUERY
};
